module.exports = __webpack_public_path__ + "img/noData.28023773.png";